import { css } from 'styled-components';
import { InvoiceInfoProps } from './models';

export const InvoiceInfo = css<InvoiceInfoProps>(({ theme }) => {
  return css`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    color: ${theme.colors.primaryDeepBlue};
    gap: 4px;
    font-size: 18px;
    text-align: center;

    > .down-payment-notice {
      color: ${theme.colors.darkGray};
      text-align: center;
      font-size: 10px;
      font-weight: 400;
      line-height: normal;
    }

    @media screen and ${theme.device.mobileXL} {
      font-size: 21px;
      font-weight: 500;
    }
  `;
});
